import { Capacitor } from '@capacitor/core'
import { StatusBar, Style } from '@capacitor/status-bar';

export default defineNuxtPlugin((_nuxtApp) => {
  if (!Capacitor.isNativePlatform()) {
    return
  }

  console.log('[cap.stat] Capacitor StatusBar plugin init')

  // Display content under transparent status bar
  StatusBar.setOverlaysWebView({ overlay: true });
  StatusBar.setStyle({ style: Style.Light });
})
